import React, { lazy } from 'react';

import { CRoutes, FlaggedRouteType } from 'src/routes';

const commonParam = ':permanenturl';

/** import pages */
const OrganizerPhysicalRaffleTicketsPage = lazy(() => import('src/pages/Account/Organizer/CommonPhysicalTickets'));
const AccountOrganizerExternalContributionsPage = lazy(
  () => import('src/pages/Account/Organizer/ExternalContributions')
);
const AccountOrganizerContributionsList = lazy(() => import('src/pages/Account/Organizer/Contributions'));
const AccountOrganizerMembersPage = lazy(() => import('src/pages/Account/Organizer/Members'));
const AccountOrganizerDonorPromoCodesPage = lazy(() => import('src/pages/Account/Organizer/DonorPromoCodes'));
const AccountOrganizerDonorEventBalancesPage = lazy(() => import('src/pages/Account/Organizer/DonorEventBalances'));
const AccountOrganizerEventRegistrationsPage = lazy(() => import('src/pages/Account/Organizer/EventRegistrations'));
const AccountOrganizerManualContributionsPage = lazy(() => import('src/pages/Account/Organizer/ManualContributions'));
const AccountOrganizerTeamsPage = lazy(() => import('src/pages/Account/Organizer/Teams'));
const AccountOrganizerEventGroupRegistrationsPage = lazy(
  () => import('src/pages/Account/Organizer/EventGroupRegistrations')
);
const AccountOrganizerRequestFundsPage = lazy(() => import('src/pages/Account/Organizer/RequestFunds'));

const AccountOrganizerAdministratorsPage = lazy(() => import('src/pages/Account/Organizer/Administrators'));
const AccountOrganizerRaffleWinnersPage = lazy(() => import('src/pages/Account/Organizer/RaffleWinners'));
const AccountOrganizerSweepstakesWinnersPage = lazy(() => import('src/pages/Account/Organizer/SweepstakesWinners'));
const AccountOrganizerSweepstakesEntriesPage = lazy(() => import('src/pages/Account/Organizer/SweepstakesEntries'));
const AccountOrganizerSweepstakeOfflineEntriesPage = lazy(
  () => import('src/pages/Account/Organizer/SweepstakeOfflineEntries')
);
const AccountOrganizerWidgetWizardPage = lazy(() => import('src/pages/Account/Organizer/WidgetWizard'));
const AccountOrganizerCrowdfundingRewardsPage = lazy(() => import('src/pages/Account/Organizer/CrowdfundingRewards'));
const AccountOrganizerPaddleRaisePage = lazy(() => import('src/pages/Account/Organizer/PaddleRaise'));
const AccountOrganizerLiveAuctionPage = lazy(() => import('src/pages/Account/Organizer/LiveAuction'));
const AccountOrganizerFundANeedPage = lazy(() => import('src/pages/Account/Organizer/FundANeed'));
const AccountOrganizerPaddleRaisePlusPage = lazy(() => import('src/pages/Account/Organizer/PaddleRaisePlus'));
const AccountOrganizerTeamMemberInvitationsPage = lazy(
  () => import('src/pages/Account/Organizer/TeamMemberInvitations')
);
const AccountOrganizerAthonPledgesPage = lazy(() => import('src/pages/Account/Organizer/AthonPledges'));
const AccountOrganizerSoldItemsPage = lazy(() => import('src/pages/Account/Organizer/SoldItems'));
/** define routes */
const getPath = (path: string) => `/account/organizer/${path}/${commonParam}`;

export const ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_RAFFLE_TICKETS = getPath('physicalRaffleTickets');
export const ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_SWEEPSTAKES_TICKETS = getPath('physicalSweepstakesTickets');
export const ROUTE_ACCOUNT_ORGANIZER_EXTERNAL_CONTRIBUTIONS = getPath('externalcontributions');
export const ROUTE_ACCOUNT_ORGANIZER_DONOR_PROMOCODES = getPath('DonorPromoCodes/Index');
export const ROUTE_ACCOUNT_ORGANIZER_DONOR_EVENT_BALANCES = getPath('donorEventBalances');
export const ROUTE_ACCOUNT_ORGANIZER_MANUAL_CONTRIBUTIONS = getPath('manualContributions');
export const ROUTE_ACCOUNT_ORGANIZER_MEMBERS = getPath('Members');
export const ROUTE_ACCOUNT_ORGANIZER_EVENT_GROUP_REGISTRATIONS = getPath('EventGroupRegistrations');
export const ROUTE_ACCOUNT_ORGANIZER_EVENT_REGISTRATIONS = getPath('eventRegistrations');
export const ROUTE_ACCOUNT_ORGANIZER_TEAMS = getPath('teams');
export const ROUTE_ACCOUNT_ORGANIZER_ADMINISTRATORS = getPath('Administrators');
export const ROUTE_ACCOUNT_ORGANIZER_RAFFLE_WINNERS = getPath('RaffleWinners');
export const ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS = getPath('SweepstakesWinners');
export const ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_ENTRIES = getPath('SweepstakesEntries');
export const ROUTE_ACCOUNT_ORGANIZER_REQUEST_FUNDS = getPath('requestFunds');

// todo
export const ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_OFFLINE_ENTRIES = getPath('sweepstakeOfflineEntries');
// todo
export const ROUTE_ACCOUNT_ORGANIZER_WIDGET_WIZARD = getPath('WidgetWizard');
export const ROUTE_ACCOUNT_ORGANIZER_CONTRIBUTIONS = getPath('contributions');
export const ROUTE_ACCOUNT_ORGANIZER_CROWDFUNDING_REWARDS = getPath('CrowdfundingRewards');
export const ROUTE_ACCOUNT_ORGANIZER_PADDLE_RAISE = getPath('PaddleRaise');
export const ROUTE_ACCOUNT_ORGANIZER_LIVE_AUCTION = getPath('LiveAuction');
export const ROUTE_ACCOUNT_ORGANIZER_FUND_A_NEED = getPath('FundANeed');
export const ROUTE_ACCOUNT_ORGANIZER_PADDLE_RAISE_PLUS = getPath('PaddleRaisePlus');
export const ROUTE_ACCOUNT_ORGANIZER_TEAM_MEMBER_INVITATIONS = getPath('TeamMemberInvitations');
export const ROUTE_ACCOUNT_ORGANIZER_ATHON_PLEDGES = getPath('AthonPledges');
export const ROUTE_ACCOUNT_ORGANIZER_SOLD_ITEMS = getPath('SoldItems');

/** generate links */
const getLink = (route: string) => (url: string) => route.replace(`${commonParam}`, url);

export const getLinkRouteAccountOrganizerPhysicalRaffleTickets = getLink(
  ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_RAFFLE_TICKETS
);
export const getLinkRouteAccountOrganizerSweepStakeTickets = getLink(
  ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_SWEEPSTAKES_TICKETS
);
export const getLinkRouteAccountOrganizerSweepstakesOfflineEntries = getLink(
  ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_OFFLINE_ENTRIES
);
export const getLinkRouteAccountOrganizerSweepstakesWinners = getLink(ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS);
export const getLinkRouteAccountOrganizerRaffleWinners = getLink(ROUTE_ACCOUNT_ORGANIZER_RAFFLE_WINNERS);
export const getLinkRouteAccountOrganizerContributions = getLink(ROUTE_ACCOUNT_ORGANIZER_CONTRIBUTIONS);
export const getLinkRouteAccountOrganizerEventGroupRegistrations = getLink(
  ROUTE_ACCOUNT_ORGANIZER_EVENT_GROUP_REGISTRATIONS
);
export const getLinkRouteAccountOrganizerExternalContributions = getLink(
  ROUTE_ACCOUNT_ORGANIZER_EXTERNAL_CONTRIBUTIONS
);
export const getLinkRouteAccountOrganizerDonorPromoCodes = getLink(ROUTE_ACCOUNT_ORGANIZER_DONOR_PROMOCODES);
export const getLinkRouteAccountOrganizerManualContributions = getLink(ROUTE_ACCOUNT_ORGANIZER_MANUAL_CONTRIBUTIONS);
export const getLinkRouteAccountOrganizerMembers = getLink(ROUTE_ACCOUNT_ORGANIZER_MEMBERS);
export const getLinkRouteAccountOrganizerTeams = getLink(ROUTE_ACCOUNT_ORGANIZER_TEAMS);
export const getLinkRouteAccountOrganizerEventRegistrations = getLink(ROUTE_ACCOUNT_ORGANIZER_EVENT_REGISTRATIONS);
export const getLinkRouteAccountOrganizerAdministrators = getLink(ROUTE_ACCOUNT_ORGANIZER_ADMINISTRATORS);
export const getLinkRouteAccountOrganizerDonorEventBalances = getLink(ROUTE_ACCOUNT_ORGANIZER_DONOR_EVENT_BALANCES);
export const getLinkRouteAccountOrganizerSweepstakesEntries = getLink(ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_ENTRIES);
export const getLinkRouteAccountOrganizerTeamMemberInvitations = getLink(
  ROUTE_ACCOUNT_ORGANIZER_TEAM_MEMBER_INVITATIONS
);

/** export flagged routes */
export const accountOrganizerFlaggedRoutes: Record<string, FlaggedRouteType> = {
  ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_OFFLINE_ENTRIES: {
    path: ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_OFFLINE_ENTRIES,
    flag: 'ReactAccountOrganizerSweepstakeOfflineEntriesPage',
    component: AccountOrganizerSweepstakeOfflineEntriesPage,
    title: 'Enter Offline Entries',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_ENTRIES: {
    path: ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_ENTRIES,
    flag: 'ReactAccountOrganizerSweepstakesEntriesPage',
    component: AccountOrganizerSweepstakesEntriesPage,
    title: 'View Sweepstakes Entries',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  ROUTE_ACCOUNT_ORGANIZER_TEAM_MEMBER_INVITATIONS: {
    path: ROUTE_ACCOUNT_ORGANIZER_TEAM_MEMBER_INVITATIONS,
    flag: 'ReactAccountOrganizerTeamMemberInvitationsPage',
    component: AccountOrganizerTeamMemberInvitationsPage,
    title: 'View Member Invitations',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  ROUTE_ACCOUNT_ORGANIZER_ATHON_PLEDGES: {
    path: ROUTE_ACCOUNT_ORGANIZER_ATHON_PLEDGES,
    flag: 'ReactAccountOrganizerAthonPledgesPage',
    component: AccountOrganizerAthonPledgesPage,
    title: 'View A-Thon Pledges',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  ROUTE_ACCOUNT_ORGANIZER_SOLD_ITEMS: {
    path: ROUTE_ACCOUNT_ORGANIZER_SOLD_ITEMS,
    flag: 'ReactAccountOrganizerSoldItemsPage',
    component: AccountOrganizerSoldItemsPage,
    title: 'View Sold Items',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
};

/** export routes */
export const accountOrganizerRoutes: CRoutes = [
  {
    path: ROUTE_ACCOUNT_ORGANIZER_CONTRIBUTIONS,
    Component: AccountOrganizerContributionsList,
    exact: true,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_RAFFLE_TICKETS,
    Component: () => <OrganizerPhysicalRaffleTicketsPage isRaffle />,
    exact: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_SWEEPSTAKES_TICKETS,
    Component: OrganizerPhysicalRaffleTicketsPage,
    exact: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_EVENT_GROUP_REGISTRATIONS,
    Component: AccountOrganizerEventGroupRegistrationsPage,
    exact: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_EXTERNAL_CONTRIBUTIONS,
    Component: AccountOrganizerExternalContributionsPage,
    exact: true,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_DONOR_PROMOCODES,
    Component: AccountOrganizerDonorPromoCodesPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_DONOR_EVENT_BALANCES,
    Component: AccountOrganizerDonorEventBalancesPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_MANUAL_CONTRIBUTIONS,
    Component: AccountOrganizerManualContributionsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_MEMBERS,
    Component: AccountOrganizerMembersPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: false,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_TEAMS,
    Component: AccountOrganizerTeamsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: false,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_EVENT_REGISTRATIONS,
    Component: AccountOrganizerEventRegistrationsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_ADMINISTRATORS,
    Component: AccountOrganizerAdministratorsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: false,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_RAFFLE_WINNERS,
    Component: AccountOrganizerRaffleWinnersPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS,
    Component: AccountOrganizerSweepstakesWinnersPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_REQUEST_FUNDS,
    Component: AccountOrganizerRequestFundsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_WIDGET_WIZARD,
    Component: AccountOrganizerWidgetWizardPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_CROWDFUNDING_REWARDS,
    Component: AccountOrganizerCrowdfundingRewardsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PADDLE_RAISE,
    Component: AccountOrganizerPaddleRaisePage,
    liveStreamBannerAvailable: false,
    showFooter: false,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_LIVE_AUCTION,
    Component: AccountOrganizerLiveAuctionPage,
    liveStreamBannerAvailable: false,
    showFooter: false,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_FUND_A_NEED,
    Component: AccountOrganizerFundANeedPage,
    liveStreamBannerAvailable: false,
    showFooter: false,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PADDLE_RAISE_PLUS,
    Component: AccountOrganizerPaddleRaisePlusPage,
    liveStreamBannerAvailable: false,
    showFooter: false,
    testModeBannerAvailable: true,
  },
];
